module.exports = __webpack_public_path__ + "static/partners-600ae90ab23b3df238513a114040a0f8.png";